import Maps from './demos/Maps'
import GridGarden from './demos/GridGarden'
import Assistent from './demos/Assistent'
import CanvasGame from './demos/CanvasGame'
import BarcodeShopper from './demos/BarcodeShopper'
import UnlimitList from './demos/UnlimitList'
import WebAuthn from './demos/WebAuthn'

const componentMap = {
    Maps,
    GridGarden,
    Assistent,
    CanvasGame,
    BarcodeShopper,
    UnlimitList,
    WebAuthn,
}

export default {
    state: {
        demos: [
            {
                name: 'Grid garden',
                description: 'Responsive design',
                component: 'GridGarden',
                icon: 'view_compact',
                searchTerms: ['mobiele weergave', 'responsive', 'mobile', 'mobiel', 'android', 'ios', 'iphone', 'grid'],
                enabled: true,
            },
            {
                name: 'Barcode Verzamelaar',
                description: 'Maak een boodschappenlijstje van producten met de barcodescanner',
                component: 'BarcodeShopper',
                icon: 'shopping_cart',
                searchTerms: ['barcode', 'scanner', 'shop', 'shopping', 'winkelwagen', 'winkelmandje', 'scannen', 'streepjescode'],
                enabled: true,
            },
            {
                name: 'Kaart navigatie',
                description: 'Voorbeeld van het weergeven van bedrijfsdata op een kaart',
                component: 'Maps',
                icon: 'map',
                searchTerms: ['maps', 'kaart', 'kaarten', 'navigatie', 'plattegrond', 'kaartnavigatie', 'fietsen'],
                hideHeader: true,
                enabled: true,
            },
            {
                name: 'Intelligente Assistent',
                description: 'Wat kost een treinkaartje van A naar B? Vraag het onze assistent.',
                component: 'Assistent',
                icon: 'how_to_reg',
                searchTerms: ['assistent', 'ai', 'artificial intelligence', 'chat', 'conversation', 'trein', 'reis', 'kaartje'],
            },
            {
                name: 'Canvas Game',
                description: 'Voorbeeld van een particle game in een canvas obv javascript classes',
                component: 'CanvasGame',
                icon: 'games',
                searchTerms: ['game', 'canvas', 'spel', 'snake', 'fliebert.JS', 'keigaaf'],
                hideHeader: true,
            },
            {
                name: 'Eindeloze lijst',
                description: 'Keep scrollin\', scrollin\', scrollin\'',
                component: 'UnlimitList',
                icon: 'format_line_spacing',
                searchTerms: ['scroll'],
                hideHeader: true,
            },
            {
                name: 'Veilige Authenticatie',
                description: 'Gestandaardiseerde beveiligde authenticatie',
                component: 'WebAuthn',
                icon: 'fingerprint',
                searchTerms: ['auth', 'authenticatie', 'inloggen', 'beveiliging', 'gebruikersnaam', 'wachtwoord'],
            },
        ],
    },

    getters: {
        demos (state) {
            return state.demos.filter((demo) => {
                if (typeof demo.enabled === 'undefined') {
                    return process.env.NODE_ENV !== 'production'
                }
                return !!demo.enabled
            })
        },
        demo (state, getters) {
            return (componentName) => {
                return getters.demos.find(demo => {
                    return demo.component === componentName
                })
            }
        },
        demoComponent () {
            return (componentName) => {
                return componentMap[componentName]
            }
        },
    },
}
